export default "__VITE_ASSET__BqVPlIum__"